var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtInput',{attrs:{"variant":"outline","placeholder":"Insira aqui seu token","type":"number","min-w":_vm.enableMinWidth ? ['auto', '375px'] : ''},model:{value:(_vm.token),callback:function ($$v) {_vm.token=$$v},expression:"token"}})}
var staticRenderFns = []

export { render, staticRenderFns }